// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7335024e","900":"a8c26bd6"}[chunkId] + ".chunk.js";
};